export default {
  desktop: {
    ThemeImporter: () => import(/* webpackChunkName: "expo-themeWrap" */'./ThemeImporter'),
  },
  mobile: {
    ThemeImporter: () => import(/* webpackChunkName: "expo-themeWrap" */'./ThemeImporter'),
  },
};
